
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/weekly-deals",
      function () {
        return require("private-next-pages/weekly-deals/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/weekly-deals"])
      });
    }
  